module.exports = __webpack_public_path__ + "static/media/swiggy_testimonial.b6f1fa3f.svg";